import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import OrderServices from "../based/services/OrderServices";
import Common from "../based/Common";
import TFUSelect from "../based/inputs/TFUSelect";
import { Notify } from "../based/Notify";
import { NOTIFY } from "../based/Constants";

const ReturnBankStatus = {
    Undefined: -1,
    Processing: 0,
    Succeed: 1,
    Canceled: 2,
    Refused: 3,
};

const ReturnBankStatusOptions = [
    {
        value: ReturnBankStatus.Undefined,
        label: "Chưa xác định",
    },
    {
        value: ReturnBankStatus.Processing,
        label: "Đang xử lý",
    },
    {
        value: ReturnBankStatus.Succeed,
        label: "Thành công",
    },
    {
        value: ReturnBankStatus.Canceled,
        label: "Đã hủy",
    },
    {
        value: ReturnBankStatus.Refused,
        label: "Bị từ chối",
    },
];

function RefundManagementEdit(props) {
    const { refundId } = props.match.params;
    const [model, setModel] = useState({});

    console.log("model", model);

    useEffect(() => {
        getData(refundId);
    }, [refundId]);

    const getData = async (id) => {
        const [err, data] = await OrderServices.GetOrderReturnBankById(id);
        if (!err && data) {
            setModel(data);
        } else {
            setModel({});
        }
    };

    if (!model) return <div className="no-data">Hiện không có dữ liệu</div>;
    return (
        <Wrapper>
            <Breadcrumbs currentPage="Chi tiết hoàn tiền" />
            <section className="button"></section>
            <section className="container-body">
                <section className="left">
                    <div className="box-card">
                        <h6>Thông tin đơn hàng</h6>
                        <div className="form-row">
                            <label htmlFor="">Mã đơn hệ thống</label>
                            <a
                                href=""
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.open(`/order-detail/${model.orderId}`, "_blank");
                                }}
                            >
                                {model.orderId}
                            </a>
                        </div>
                        <div className="form-row">
                            <label htmlFor="">Mã đơn hàng</label>
                            <span>{model.orderNumber}</span>
                        </div>
                        <div className="form-row">
                            <label htmlFor="">Tên khách</label>
                            <span>{model.userName}</span>
                        </div>
                        <div className="form-row">
                            <label htmlFor="">SĐT</label>
                            <span>{model.phoneNumber}</span>
                        </div>
                    </div>
                    <div className="box-card">
                        <h6>Lý do hoàn tiền</h6>
                        <div className="form-row">
                            <label htmlFor="">Lý do hoàn tiền</label>
                            {/* <span>Hàng lỗi</span> */}
                        </div>
                    </div>
                    <div className="box-card">
                        <h6>Thông tin hoàn tiền</h6>
                        <div className="form-row">
                            <label htmlFor="">Ngân hàng</label>
                            <span>{model.bankName}</span>
                        </div>
                        <div className="form-row">
                            <label htmlFor="">STK</label>
                            <span>{model.bankAccountNumber}</span>
                        </div>
                        <div className="form-row">
                            <label htmlFor="">Tên tài khoản</label>
                            <span>{model.bankAccountName}</span>
                        </div>
                        <hr />
                        <div className="form-row">
                            <label htmlFor="">Trạng thái</label>
                            {/* <span>{model.statusName}</span> */}
                            <div className="status-section">
                                <TFUSelect
                                    options={ReturnBankStatusOptions}
                                    value={model.status}
                                    onChanged={async (val) => {
                                        const [err, data] = await OrderServices.UpdateOrderReturnBankStatus(refundId, +val);
                                        if (!err) {
                                            let md = { ...model };
                                            md.status = val;
                                            setModel(md);
                                        } else {
                                            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Cập nhật trạng thái không thành công");
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="right">
                    <div className="box-card">
                        <h6>Số tiền cần hoàn</h6>
                        <section className="table-refund">
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">STT</th>
                                        <th scope="col">Hình ảnh</th>
                                        <th scope="col">Sản phẩm</th>
                                        <th scope="col">Giá bán</th>
                                        <th scope="col">Giá giảm</th>
                                        <th scope="col">Số lượng</th>
                                        <th scope="col">Tổng</th>
                                        <th scope="col">Hoàn tiền</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {model && model.orderReturnProducts && model.orderReturnProducts.length > 0 ? (
                                        model.orderReturnProducts.map((item, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td className="vertical-align-middle">{idx + 1}</td>
                                                    <td className="vertical-align-middle">
                                                        <div className="lst-image">
                                                            {item.frontImage && <img src={item.frontImage} alt="" />}
                                                            {item.backImage && <img src={item.backImage} alt="" />}
                                                        </div>
                                                    </td>
                                                    <td className="vertical-align-middle">
                                                        <div className="refund-detail">
                                                            <a
                                                                className="refund-order"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    e.stopPropagation();
                                                                }}
                                                            >
                                                                {item.title}
                                                            </a>
                                                            <span>
                                                                <strong>{item.name}</strong>
                                                            </span>
                                                            <span>
                                                                {item.color}, Size {item.size}
                                                            </span>
                                                        </div>
                                                    </td>
                                                    <td className="vertical-align-middle">{Common.formatCurrency(item.price)}</td>
                                                    <td className="vertical-align-middle">{Common.formatCurrency(item.salePrice)}</td>
                                                    <td className="vertical-align-middle">
                                                        <strong>{item.quantity}</strong>
                                                    </td>
                                                    <td className="vertical-align-middle">{Common.formatCurrency(item.finallyPrice)}</td>
                                                    <td className="vertical-align-middle">{Common.formatCurrency(item.refundAmount)}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={8}>Không có dữ liệu</td>
                                        </tr>
                                    )}

                                    <tr>
                                        <td colSpan={8}>
                                            <div className="text-right">
                                                <span>
                                                    Số tiền cần hoàn <strong>{Common.formatCurrency(model.refundAmount)}</strong>
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </section>
                    </div>
                </section>
            </section>
        </Wrapper>
    );
}

export default RefundManagementEdit;

const Wrapper = styled.div`
    .status-section {
        flex: 1;
    }

    .lst-image img {
        width: 90px;
        height: 90px;
        object-fit: contain;
        margin: 4px;
    }

    .refund-detail {
        display: flex;
        flex-direction: column;
    }

    .lst-image {
        width: 200px;
    }

    .text-right span strong {
        font-size: 30px;
    }

    .text-right span {
        align-items: flex-end;
        vertical-align: middle;
    }

    .box-card {
        border: 1px solid #f1f1f1;
        background: #fff;
        margin: 12px 0;
        padding: 16px 20px;
    }

    section.container-body {
        display: flex;
    }

    section.left {
        width: 475px;
        margin-right: 12px;
    }

    section.right {
        flex: 1;
    }

    .form-row {
        align-items: center;
        margin: 6px 0;
    }

    .form-row label {
        margin: 0;
        width: 30%;
    }

    .form-row span {
        flex: 1;
    }
`;
